import { Component } from "@angular/core";

@Component({
  selector: "app-account-details",
  templateUrl: "./account-details.component.html",
})
export class AccountDetailsComponent {}
